import React from 'react';
import Header from '../Header';
import { Helmet } from 'react-helmet-async';
import Footer from './Footer';
import '../../css/LegalPages.css';

const LegalNotices = () => {
    return (
        <>
            <Helmet>
                <title>Mentions légales | CC Débarras 14</title>
                <meta name="description" content="Mentions légales de CC Débarras 14, entreprise de débarras à Saint-Arnoult (14800), Calvados." />
                <link rel="canonical" href="https://ccdebarras14.fr/mentions-legales" />
                <meta property="og:title" content="Mentions légales | CC Débarras 14" />
                <meta property="og:description" content="Mentions légales de CC Débarras 14, entreprise de débarras à Saint-Arnoult (14800), Calvados." />
                <meta property="og:url" content="https://ccdebarras14.fr/mentions-legales" />
                <meta property="og:type" content="website" />
            </Helmet>

            <Header />
            <div className="legal-page">
                <div className="legal-content">
                    <h1>Mentions Légales</h1>
                    
                    <section className="legal-section">
                        <h2>1. Informations sur l'entreprise</h2>
                        <p><strong>Raison sociale :</strong> MADAME CARINE GAUTHERIE</p>
                        <p><strong>Nom commercial :</strong> CC Débarras 14</p>
                        <p><strong>Forme juridique :</strong> Entrepreneur individuel</p>
                        <p><strong>Numéro SIREN :</strong> 848 965 612</p>
                        <p><strong>Numéro SIRET du siège social :</strong> 848 965 612 00015</p>
                        <p><strong>Code APE :</strong> 8121Z - Nettoyage courant des bâtiments</p>
                        <p><strong>TVA Intracommunautaire :</strong> FR52848965612</p>
                        <p><strong>Adresse du siège social :</strong> RUE DES GENETS 7598 LE BIEF DU MOULIN, 14800 SAINT-ARNOULT, France</p>
                        <p><strong>Téléphone :</strong> 07 67 56 72 54</p>
                        <p><strong>Email :</strong> <a href="mailto: ccdebarras14@gmail.com">ccdebarras14@gmail.com</a></p>
                        <p><strong>Date de création :</strong> 01 avril 2019</p>
                    </section>

                    <section className="legal-section">
                        <h2>2. Directeur de la publication</h2>
                        <p><strong>Nom :</strong> MADAME CARINE GAUTHERIE</p>
                        <p><strong>Qualité :</strong> Entrepreneur individuel</p>
                    </section>

                    <section className="legal-section">
                        <h2>3. Activité de l'entreprise</h2>
                        <p><strong>Domaine d'activité :</strong> Services relatifs aux bâtiments et aménagement paysager</p>
                        <p><strong>Activité principale :</strong> Nettoyage courant des bâtiments (Code NAF 8121Z)</p>
                        <p><strong>Type d'activité :</strong> Libérale non réglementée</p>
                        <p><strong>Convention collective :</strong> Entreprises de propreté et services associés (3043)</p>
                        <p>L'entreprise est spécialisée dans les services de débarras professionnels, le tri et la valorisation d'objets, intervenant principalement à Deauville et dans les communes environnantes de Normandie.</p>
                    </section>

                    <section className="legal-section">
                        <h2>4. Hébergement du site</h2>
                        <p><strong>Hébergeur :</strong> OVH SAS</p>
                        <p><strong>Adresse :</strong> 2 rue Kellermann, 59100 Roubaix, France</p>
                        <p><strong>Téléphone :</strong> 1007 (numéro non surtaxé depuis la France)</p>
                        <p><strong>Site web :</strong> <a href="https://www.ovh.com" target="_blank" rel="noopener noreferrer">www.ovh.com</a></p>
                        <p><strong>SIRET :</strong> 424 761 419 00045</p>
                    </section>

                    <section className="legal-section">
                        <h2>5. Propriété intellectuelle</h2>
                        <p>Le contenu de ce site web (textes, images, graphismes, logo, icônes, sons, logiciels) est la propriété exclusive de CC Débarras 14, à l'exception des marques, logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs.</p>
                        <p>Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de MADAME CARINE GAUTHERIE.</p>
                    </section>

                    <section className="legal-section">
                        <h2>6. Responsabilité</h2>
                        <p>Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes.</p>
                        <p>CC Débarras 14 ne pourra en aucun cas être tenue responsable de tout dommage de quelque nature qu'il soit résultant de l'interprétation ou de l'utilisation des informations et/ou documents disponibles sur ce site.</p>
                    </section>

                    <section className="legal-section">
                        <h2>7. Liens hypertextes</h2>
                        <p>Les liens hypertextes mis en place dans le cadre du présent site web en direction d'autres ressources présentes sur le réseau Internet (notamment vers les plateformes Leboncoin et Facebook Marketplace) ne sauraient engager la responsabilité de CC Débarras 14.</p>
                    </section>

                    <section className="legal-section">
                        <h2>8. Collecte et traitement de données</h2>
                        <p>Conformément aux dispositions de la loi n° 78-17 du 6 janvier 1978 modifiée et du Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de modification et de suppression des données qui vous concernent.</p>
                        <p>Pour exercer ce droit, adressez-vous à : [email à compléter]</p>
                    </section>

                    <section className="legal-section">
                        <h2>9. Droit applicable et juridiction compétente</h2>
                        <p>Tout litige en relation avec l'utilisation du site de CC Débarras 14 est soumis au droit français. En dehors des cas où la loi ne le permet pas, il est fait attribution exclusive de juridiction aux tribunaux compétents de Caen.</p>
                    </section>

                    <section className="legal-section">
                        <h2>10. Informations professionnelles</h2>
                        <p><strong>Statut INSEE :</strong> Inscrit depuis le 01 avril 2019</p>
                        <p><strong>Statut RNE :</strong> Inscrit depuis le 01 avril 2019</p>
                        <p><strong>Taille de l'entreprise :</strong> PME (Année 2022)</p>
                        <p><strong>Procédure collective :</strong> Aucune</p>
                        <p>L'entreprise est active et en règle avec ses obligations déclaratives.</p>
                    </section>

                    <section className="legal-section">
                        <p><strong>Date de dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}</p>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default LegalNotices;